import { ChannelApiKey } from '@/micros/homepage/settings/api-key-management/api-key-management';
import { Get, Delete, Post } from '../helpers';

export function GetChannelApiKeys(channel: number): Promise<ChannelApiKey[]> {
  return Get({ url: `/v3/admin/auth/channel-keys/${channel}` });
}

export function CreateChannelApiKey(channel: number): Promise<Response> {
  return Post({ url: `/v3/admin/auth/channel-keys/${channel}/generate-key` });
}

export function DeactivateChannelApiKey(channel: number, keyId: string) {
  return Delete({ url: `/v3/admin/auth/channel-keys/${channel}/${keyId}` });
}
